import { useState } from 'react';

function Terminal() {
    const [lines, setLines] = useState([
        'Bienvenue dans mon terminal !',
        'Tapez "help" pour voir les commandes disponibles.'
    ]);
    const [command, setCommand] = useState('');
    const [commandHistory, setCommandHistory] = useState([]);

    const executeCommand = (event) => {
        if (event.key !== 'Enter') {
            return;
        }

        const trimmedCommand = command.trim();
        if (!trimmedCommand) {
            return;
        }

        if (trimmedCommand === 'clear') {
            setLines([]);
            setCommand('');
            setCommandHistory((history) => [...history, { command: trimmedCommand, output: [] }]);
            return;
        }

        let output;
        switch (trimmedCommand) {
            case 'help':
                output = [
                    'Commandes disponibles :',
                    '- help : Affiche cette aide',
                    '- clear : Efface le terminal',
                    '- about : À propos de moi',
                    '- historique : Affiche l\'historique des commandes'
                ];
                break;
            case 'about':
                output = ['Bienvenue sur mon portfolio, je suis Romain Dauriach, administrateur système et réseaux.'];
                break;
            case 'historique':
                output = commandHistory.length === 0
                    ? ['Aucune commande dans l\'historique.']
                    : [
                        'Historique des commandes :',
                        ...commandHistory.map((entry, index) => `${index + 1}. ${entry.command}`)
                    ];
                break;
            default:
                output = [`Commande inconnue : "${trimmedCommand}". Tapez "help" pour voir les commandes disponibles.`];
        }

        setLines((currentLines) => [
            ...currentLines,
            `user@host:~$ ${trimmedCommand}`,
            ...output
        ]);
        setCommandHistory((history) => [...history, { command: trimmedCommand, output }]);
        setCommand('');
    };

    return (
        <div className="terminal-container">
            <div className="terminal" id="terminal">
                {lines.map((line, index) => <div key={`${line}-${index}`}>{line}</div>)}
            </div>
            <div className="terminal-input">
                <span className="terminal-prompt">user@host:~$</span>
                <input
                    type="text"
                    className="terminal-command"
                    id="command-input"
                    value={command}
                    onChange={(event) => setCommand(event.target.value)}
                    onKeyDown={executeCommand}
                    autoFocus
                    aria-label="Commande du terminal"
                    inputMode="text"
                    autoCapitalize="off"
                />
            </div>
        </div>
    );
}

export default Terminal;